import { readonly, ref, type Ref } from 'vue';

// Height (px) currently occupied by the fixed bottom comparison bar
// (StickyBottom). Published by the bar itself, consumed by other floating
// bottom-anchored UI (the mobile nav FAB) so they stack above it instead of
// covering its buttons. 0 when the bar is hidden.
const inset = ref(0);

export function useBottomBarInset(): Readonly<Ref<number>> {
  return readonly(inset);
}

export function setBottomBarInset(px: number): void {
  inset.value = px;
}
